import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';

const CheckoutTerms = ({ t, onChange, checked }) => {
  const privacyPolicy = '/privacy-policy';
  const termsPolicy = '/terms-and-conditions';
  const termsMessage = (
    <div className="terms-box">
      {t('shop.product.terms.initial')}
      <a href={privacyPolicy} target="_blank" rel="noreferrer" className="terms">{` ${t('shop.product.terms.privacy')} `}</a>
      {t('shop.product.terms.continuation')}
      <a href={termsPolicy} target="_blank" rel="noreferrer" className="terms">
        {` ${t('shop.product.terms.ofUse')}`}
      </a>
      .
    </div>
  );

  return (
    <div className="check-terms">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */}
      <label className="m-checkbox m-checkbox--state-success">
        <input type="checkbox" onChange={onChange} checked={checked} />
        <span />
      </label>
      {termsMessage}
    </div>
  );
};

CheckoutTerms.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default compose(
  translate,
)(CheckoutTerms);
